import { render, staticRenderFns } from "./ImageStreaming.vue?vue&type=template&id=fc297d9c&scoped=true"
import script from "./ImageStreaming.vue?vue&type=script&lang=js"
export * from "./ImageStreaming.vue?vue&type=script&lang=js"
import style0 from "./ImageStreaming.vue?vue&type=style&index=0&id=fc297d9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc297d9c",
  null
  
)

export default component.exports